<div class="container account-result-page">
  <div class="row justify-content-center align-items-start">
    <div *ngIf="isLoading" class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div
      *ngIf="activationSuccess"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8"
    >
      Your email address has been verified. Continue to your account
      <a
        [routerLink]="['/', tenantSubdomain, 'login']"
        >here</a
      >
    </div>
    <div
      *ngIf="activationFailure"
      class="card-footer alert alert-danger col-12 col-xs-9 col-lg-8"
    >
      This email verification link is invalid or has expired. Your account and household are unchanged. Sign in to request a new link.
      <a
        [routerLink]="['/', tenantSubdomain, 'email-access']"
        >here</a
      >.
    </div>
  </div>
</div>
